import { Injectable } from '@angular/core';
import { ApplicationInsights, ICustomProperties } from '@microsoft/applicationinsights-web';

import { environment } from '../environments/environment';

@Injectable({
	providedIn: 'root',
})
export class LoggingService {
	private readonly appInsights: ApplicationInsights;

	constructor() {
		this.appInsights = new ApplicationInsights({
			config: {
				instrumentationKey: environment.appInsights.instrumentationKey,
				enableAutoRouteTracking: true,
				cookieCfg: {
					/** fixes crossorigin issue since we're using the SDK and not script tag */
					domain: `.embracepetinsurance.com`,
				},
			},
		});

		this.appInsights?.loadAppInsights();
	}

	/** Manually log a page view event */
	public logPageView(name?: string, uri?: string): void {
		this.appInsights.trackPageView({
			name,
			uri,
		});
	}

	/** Manually log an event */
	public logEvent(name: string, properties: ICustomProperties): void {
		this.appInsights.trackEvent({ name }, properties);
	}

	/** Manually log a metric */
	public logMetric(name: string, average: number, properties: ICustomProperties): void {
		this.appInsights.trackMetric({ name, average }, properties);
	}

	/** Manually log an exception */
	public logException(exception: Error, severityLevel?: number): void {
		this.appInsights.trackException({ exception, severityLevel });
	}

	/** Manually log a trace */
	public logTrace(message: string, properties: ICustomProperties): void {
		this.appInsights.trackTrace({ message }, properties);
	}
}
